import ProductGrid from "../components/ProductGrid";

export default function Shop() {
  return (
    <div data-testid="shop-page" className="bg-ll-black text-ll-bone">
      <div className="relative mx-auto max-w-7xl overflow-hidden px-5 pb-24 pt-40 md:px-8">
        <p aria-hidden="true" className="pointer-events-none absolute -top-4 right-0 select-none font-display text-[26vw] leading-none text-transparent md:text-[17rem]"
           style={{ WebkitTextStroke: "1px rgba(242,240,233,0.12)" }}>
          N°1
        </p>
        <p className="relative font-tech text-[11px] tracking-[0.3em] text-ll-red">THE CATALOG</p>
        <h1 data-testid="shop-heading" className="relative mt-2 font-display text-6xl tracking-wide md:text-8xl">
          THE SHELF
        </h1>
        <p className="relative mt-4 max-w-md text-sm leading-relaxed text-ll-bone/60">
          Every piece on the shelf ships as shown. Add to cart, check out in a minute, and it changes the room.
        </p>
        <div className="relative mt-10">
          <ProductGrid />
        </div>
      </div>
    </div>
  );
}
